import { TypeAheadFilter } from '@components/table/filters/TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';

import { useSearchOfferingInsuranceProducts } from '@services/offering/useSearchOfferingInsuranceProducts';
import { useProductLabels } from '@services/productLabel';
import { useMemo } from 'react';

export interface ProductLabelTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

/** FUTURE CONSIDERATIONS
 * at this time the used apis are not paginated/load more on scroll (but it does load 50)
 * this may eventually need to load more on scroll
 */
export const ProductLabelTypeaheadFilter = (componentProps: ProductLabelTypeaheadFilterProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { other, value, fieldConfig, watchedField, selectedValues = {}, disabled, ...rest } = componentProps;

  // will be a value when selected from list - but just a string if loaded from shared url
  const selectedOfferings = watchedField ? selectedValues?.[watchedField] : undefined;
  const offeringId = useMemo(() => {
    if (!selectedOfferings) {
      return undefined;
    }

    if (!Array.isArray(selectedOfferings)) {
      return selectedOfferings.value ?? selectedOfferings;
    }

    if (selectedOfferings.length === 1) {
      return selectedOfferings[0]?.value ?? selectedOfferings[0];
    }
    if (selectedOfferings.length > 1) {
      // Multiple is not supported
      return undefined;
    }
  }, [selectedOfferings]);

  const { insuranceProducts } = useSearchOfferingInsuranceProducts(offeringId);

  // FUTURE: at some point we may need to handle multiple insurance products
  const insuranceProductId = insuranceProducts?.length > 0 ? insuranceProducts[0].id : '';
  const { productLabels } = useProductLabels(insuranceProductId);

  const items = productLabels?.map((ip) => {
    return {
      key: ip.id,
      value: ip.id,
      label: ip.name,
    };
  });

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled || (!value && items.length === 0)}
      label={componentProps.label}
      options={items ?? []}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      helperText={selectedOfferings?.length > 1 ? 'Only available if one product is selected' : undefined}
    />
  );
};
